import { CustomTextField } from '@/components/Formik/CustomTextField';
import { Button, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { InstitutionalPageData } from './View';

interface ICompanyDescriptionProps {
  onAdvancedStep: () => void;
}

const CompanyDescription = ({ onAdvancedStep }: ICompanyDescriptionProps) => {
  const { errors } = useFormikContext<InstitutionalPageData>();

  function handleAdvanceStep() {
    if (errors.description) return;
    onAdvancedStep();
  }
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          mb: '4px',
          textAlign: 'left',
        }}
      >
        Conte mais sobre a sua empresa
      </Typography>
      <Typography
        variant="body2"
        sx={{
          textAlign: 'left',
          mb: 2,
        }}
      >
        Adicione uma descrição de sua empresa e um breve resumo de seus produtos
        e serviços.
      </Typography>

      <CustomTextField
        fullWidth
        variant="standard"
        name="description"
        placeholder="Sobre (opcional)"
        label="Sobre (opcional)"
        multiline
      />

      <Button
        variant="contained"
        onClick={handleAdvanceStep}
        className="submitButton"
        fullWidth
      >
        Próximo
      </Button>
    </>
  );
};

export default CompanyDescription;
export type { ICompanyDescriptionProps };
